var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTelegramSquare = function SvgIconTelegramSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.325 22.649c.313-.96 1.78-10.533 1.961-12.42.055-.57-.126-.95-.48-1.12-.427-.206-1.06-.103-1.795.162-1.008.363-13.893 5.834-14.638 6.151-.706.3-1.373.627-1.373 1.1 0 .333.198.52.742.715.567.202 1.995.635 2.837.868.812.224 1.736.03 2.254-.293.55-.34 6.886-4.581 7.341-4.953s.817.105.446.477c-.372.371-4.722 4.593-5.295 5.178-.696.71-.202 1.445.265 1.74.534.335 4.37 2.91 4.948 3.322.578.413 1.164.6 1.7.6.537 0 .82-.706 1.087-1.527"
  })));
};
export default SvgIconTelegramSquare;